import { SIDEBAR_COLLAPSED_KEY } from "../state/app";

export default {
  setAppLoaded(state) {
    state.appLoaded = true;
  },
  setSnackbar(state, { text, enabled }) {
    state.app.snackbar.text = text;
    state.app.snackbar.enabled = enabled;
  },
  clearSnackbar(state) {
    state.app.snackbar.text = "";
    state.app.snackbar.enabled = false;
  },
  setLoader(state) {
    state.app.loader = true;
  },
  clearLoader(state) {
    state.app.loader = false;
  },
  setDrawer(state) {
    state.app.drawer = true;
  },
  clearDrawer(state) {
    state.app.drawer = false;
  },
  setIsMobileView(state, isMobile) {
    state.app.isMobileView = isMobile;
  },
  setSidebarCollapsed(state, collapsed) {
    state.app.sidebarCollapsed = !!collapsed;
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(!!collapsed));
    } catch (e) {
      // Sin acceso a localStorage (modo privado, etc.): solo se pierde la preferencia.
    }
  },
};
